import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

const index = props => {
  const { text, osIcon, onClick, btnClass } = props;
  return (
    <a
      className={`ideal-item-button btn ${btnClass} btn-sm`}
      href="#"
      aria-label={text}
      onClick={onClick}
    >
      <i className={`os-icon ${osIcon}`} />
      <span>{text}</span>
    </a>
  );
};

index.defaultProps = {
  onClick: () => null,
  osIcon: 'os-icon-plus-circle',
  btnClass: 'btn-grey',
};

index.propTypes = {
  text: PropTypes.string.isRequired,
  osIcon: PropTypes.string.isRequired,
  btnClass: PropTypes.string,
  onClick: PropTypes.func,
};

export default index;
